import React from 'react';
import Layout from '@rezdy/components/Layout/DarkCentered';
import { Article, Aside, Body } from '@rezdy/components/Layout/Article/Styled';
import SecondaryAction from '../../components/Layout/SecondaryAction';
import VerifyEmailSuccess from '../../components/SignUpV2/VerifyEmailSuccess';
import VerifyEmailError from '../../components/SignUpV2/VerifyEmailError';
import VerifyEmailExpiredLink from '../../components/SignUpV2/VerifyEmailExpiredLink';
import Grid from '@rezdy/components/Grid';
import TextStyle from '@rezdy/components/TextStyle';
import { H4 } from '@rezdy/components/Heading';
import Icon from '@rezdy/components/Icon';
import queryString from '../../services/queryString';
import routing from '../../services/routing';
import verifyEmail from '../../actions/verifyEmail';
import { withTranslation, WithTranslation } from 'react-i18next';
import { EMAIL_VERIFIED, EXPIRED_REFRESH_TOKEN, INVALID_ENTITY } from '../../constants/errorCodes';
import EmailVerified from '../../components/SignUpV2/EmailVerified';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { DEFAULT_SIGNUP_VERSION } from '../../services/auth';
import { BookingSoftwareMarketingCard } from '../../components/BookingSoftwareMarketingCard';
import pendo from '../../services/pendo';

const SUPPORTED_VERSIONS = [DEFAULT_SIGNUP_VERSION, '3'];

export class EmailVerification extends React.Component<WithTranslation & RouteComponentProps<{ version: string }>> {
    state = {
        loading: true,
        emailVerification: '',
        username: '',
    };

    async componentDidMount() {
        const params = queryString.parse(routing.location.search);
        const username = decodeURIComponent((params.username as string) || '');
        const code = decodeURIComponent((params.code as string) || '');
        const version = SUPPORTED_VERSIONS.includes(this.props.match.params.version)
            ? this.props.match.params.version
            : DEFAULT_SIGNUP_VERSION;
        const emailVerification = await verifyEmail({ username, code }, version);
        if (emailVerification === 'EMAIL_VERIFIED') {
            pendo.trackEvent(pendo.buildAnonymousVisitor({ email: username }), 'Old Sign Up - Email Verified');
        }
        this.setState({
            emailVerification,
            username,
            loading: false,
        });
    }

    renderLoading = () => {
        const { i18n } = this.props;
        return (
            <TextStyle align="center">
                <H4>
                    {i18n.t('emailVerification.heading')}
                    <Icon name="loader-dots" size="large" />
                </H4>
            </TextStyle>
        );
    };

    renderEmailVerification = (responseType: string) => {
        if (this.state.loading) {
            return this.renderLoading();
        }

        switch (responseType) {
            case EMAIL_VERIFIED:
                return <VerifyEmailSuccess />;
            case EXPIRED_REFRESH_TOKEN:
                return <VerifyEmailExpiredLink username={this.state.username} />;
            case INVALID_ENTITY:
                return <EmailVerified />;
            default:
                return <VerifyEmailError />;
        }
    };

    render(): React.ReactNode {
        return (
            <Layout secondaryAction={<SecondaryAction />}>
                <Article style={{ alignItems: this.state.loading ? 'center' : 'start' }}>
                    <Body>
                        <Grid.Container rowGap="24px" style={{ maxWidth: 400 }}>
                            {this.renderEmailVerification(this.state.emailVerification)}
                        </Grid.Container>
                    </Body>
                    <Aside>
                        <BookingSoftwareMarketingCard />
                    </Aside>
                </Article>
            </Layout>
        );
    }
}

export default withTranslation()(withRouter(EmailVerification));
